/**
 * Turns an axios error into a user-facing Spanish message.
 *
 * A 403 always gets a fixed Spanish message -- the backend's `error` field on
 * a Forbidden response is often an untranslated English string (e.g.
 * "Forbidden: finanzas panel required") that would otherwise leak into the
 * UI verbatim. For any other status, the backend's `error` field is used
 * when present (most validation messages are already correctly in Spanish),
 * falling back to `fallback` when absent.
 */
export function getErrorMessage(err: any, fallback: string): string {
  if (err?.response?.status === 403) {
    return 'No tienes permiso para realizar esta acción.'
  }
  return err?.response?.data?.error || fallback
}
